import './FacilityDetailsComponent.scss';
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {CommonService} from "../../../shared/services";

interface FacilityDetailsComponentProps {
    title?: any;
}

const FacilityDetailsComponent = (props: FacilityDetailsComponentProps) => {

    const {title} = props;

    const {
        facilityList
    } = useSelector((state: IRootReducerState) => state.staticData);


    return (
        <div className="facility-details-component">
            <div className={'title'}>
                {title}
            </div>
            <div className={'wrapper'}>
                {
                    facilityList?.map((facility, index) => {
                        return (<div className={'facility-details-wrapper'}>
                                <div className={'facility-name'}>
                                    {facility?.name}
                                </div>
                                <div className={'facility-address'}>
                                    <div>Address: &nbsp;{facility?.address?.address_line}, {facility?.address?.state}, {facility?.address?.city} {facility?.address?.zip_code}</div>
                                    <div> Phone: &nbsp;{CommonService.formatPhoneNumber(facility?.primary_contact_info?.phone)}</div>
                                    <div className={'mrg-bottom-20'}>Email: &nbsp;{facility?.primary_email}</div>
                                </div>

                            </div>

                        )
                    })
                }
            </div>

        </div>
    )

}

export default FacilityDetailsComponent
